var SCM = SCM || {};

SCM.TermsAndConditions = (function ($) {
    const $TermsAndConditionsWidget = $('.widget-TermsAndConditionsViewModel');
    const $Backdrop = $TermsAndConditionsWidget.find('.terms-conditions-modal-backdrop');
    const $TermsAndConditionsModal = $TermsAndConditionsWidget.find('.js-terms-conditions');
    const $AcceptButton = $TermsAndConditionsModal.find('.js-terms-conditions-agree');
    const $DeclineButton = $TermsAndConditionsModal.find('.js-terms-conditions-decline');
    const Hide = 'hide';

    return {
        init
    };

    function init() {
        if (!$TermsAndConditionsWidget.length) {
            return;
        }

        $AcceptButton.on('click', _acceptTsAndCs);
        $DeclineButton.on('click', _declineTsAndCs);
        _toggleFocusTrap(true);
    }

    function _acceptTsAndCs() {
        const ajaxUrl = $(this).data('ajax-url');
        if (ajaxUrl.length) {
            SCM.Ajax
                .post(ajaxUrl)
                .expectActionResultModel()
                .catch(error => console.log(error));

            _closeModal();
        }
    }

    function _declineTsAndCs() {
        const ShowErrorOnDecline = $TermsAndConditionsWidget.find('#hfShowErrorOnDecline').val();

        if (ShowErrorOnDecline && ShowErrorOnDecline.toLowerCase() === 'true') {
            _displayErrorMessage();
            return;
        }

        _closeModal();
    }

    function _displayErrorMessage() {
        const $ErrorMessage = $TermsAndConditionsWidget.find('.js-terms-conditions-error');
        if ($ErrorMessage.length) {
            $ErrorMessage.removeClass(Hide);
            $DeclineButton.blur();
        }
    }

    function _closeModal() {
        $TermsAndConditionsModal.removeClass('open');
        _toggleFocusTrap(false);
        _hideBackdrop();
    }

    function _toggleFocusTrap(enable) {
        if (enable) {
            SCM.Focus.trap($TermsAndConditionsWidget);
        } else {
            SCM.Focus.release($TermsAndConditionsWidget);
        }
    }

    function _hideBackdrop() {
        if ($Backdrop.length) {
            $Backdrop.addClass(Hide);
        }
    }
})(jQuery);
